import * as Sentry from "@sentry/nextjs";

// const SENTRY_DSN = process.env.SENTRY_DSN;
const SENTRY_DSN = 'https://0f20ae831f9e481384bada0ed896233f@o1164590.ingest.sentry.io/6253755';
Sentry.init({
  // debug: true,
  dsn: SENTRY_DSN,
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  integrations: [
    new Sentry.Integrations.Breadcrumbs({
      console: false
    })
  ],
  tracesSampleRate: 0.0,
  environment: "dev",
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});